module.exports = __webpack_public_path__ + "img/cloundwise2.f46a4a42.png";